import { createSelector } from "reselect";

export const getWebhookState = (state) => state.webhooks || {};

export const getWebhookConfiguration = createSelector(
  getWebhookState,
  (webhookState) => webhookState.configuration || null
);

export const getSuspendedSecrets = createSelector(
  getWebhookState,
  (webhookState) => webhookState.suspendedSecrets || null
);

export const findWebhookConfigurationByType = (webhookData, type) => {
  return webhookData?.webhookConfiguration?.find(
    (config) => config.type === type
  );
};
